import { VHCRecordLogInput, VhcRecordLogService } from 'api/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

type VhcRecordsRepairPartsProps = {
  id: number;
  requestBody?: VHCRecordLogInput;
};

export const useUpdateVhcRecordsMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof VhcRecordLogService.putVhcRecords>>,
      QueryError,
      VhcRecordsRepairPartsProps,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ id, requestBody }: VhcRecordsRepairPartsProps) => {
      return VhcRecordLogService.putVhcRecords(id, requestBody);
    },
    {
      ...options,
      onSuccess: () => {
        toast.success('Successfully created!');
      },
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
        console.error(message);
      }
    }
  );
